// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","grey200":"#E6E6EC","tablet":"768px","desktop":"1200px","container":"SmartAppBanner_container__ePJa7","headerHidden":"SmartAppBanner_headerHidden__JECox"};